<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .field-mapping {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-top: utils.in_rem(16px);
    gap: utils.in_rem(10px);
  }

  .table-header {
    background-color: colors.get(interfaceSwGrey_5);
  }

  .title {
    @include mixins.h3();
    margin: 0;
  }

  .table-wrapper {
    border: 1px solid colors.get(interfaceSwGrey_10);
    border-radius: utils.in_rem(10px);
    padding: utils.in_rem(6px);
  }
</style>

<script>
  import { onMount } from "svelte";
  import {
    activeProviderConfigStore,
    providerConfigDraftStore,
  } from "../../../../../stores";
  import { fieldSettingsStore } from "../../../../../stores/fieldSettings";
  import SearchInput from "./components/SearchInput.svelte";
  import TableBody from "./components/TableBody.svelte";
  import TableHeader from "./components/TableHeader.svelte";

  export let type;

  let searchQuery = "";
  let filteredFields = [];
  let isLoading = true;

  const getFieldInfo = (store, key) => {
    const values = store?.optionValues || [];
    return values.find((opt) => opt.key === key)?.info || "";
  };

  // Get tooltip info using the getFieldInfo function
  $: displayedFieldInfo = getFieldInfo(
    $activeProviderConfigStore,
    "displayedAdvancedOptions"
  );
  $: mandatoryFieldInfo = getFieldInfo(
    $activeProviderConfigStore,
    "mandatoryFields"
  );
  $: protectedFieldInfo = getFieldInfo(
    $activeProviderConfigStore,
    "protectedFields"
  );

  const loadAndFilterFields = () => {
    const fields = $fieldSettingsStore(type);
    filteredFields = searchQuery
      ? fields.filter((field) =>
          field.label.toLowerCase().includes(searchQuery.toLowerCase())
        )
      : fields;
  };

  onMount(() => {
    // Push to next event loop cycle to allow UI to render first
    setTimeout(() => {
      loadAndFilterFields();
      isLoading = false;
    }, 0);
  });

  // Reload fields when search query changes or when store changes
  $: if (searchQuery !== undefined && !isLoading) {
    loadAndFilterFields();
  }

  // Also reload fields when the draft store changes
  $: if ($providerConfigDraftStore && !isLoading) {
    loadAndFilterFields();
  }
</script>

<div class="field-mapping">
  <h3 class="title">{type === "ClientContact" ? "Contact" : type} fields</h3>

  <SearchInput bind:value={searchQuery} />

  <div class="table-wrapper">
    <TableHeader
      {displayedFieldInfo}
      {mandatoryFieldInfo}
      {protectedFieldInfo}
    />
    <TableBody {filteredFields} {isLoading} {type} />
  </div>
</div>
